import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgOptimizedImage } from "@angular/common";
import { InfoIconComponent } from "../../info-icon/info-icon/info-icon.component";

@Component({
  selector: "app-page-content-header",
  templateUrl: "./page-content-header.component.html",
  styleUrl: "./page-content-header.component.css",
  imports: [TranslateModule, NgOptimizedImage, InfoIconComponent],
})
export class PageContentHeaderComponent {

  @Input() title1: string;
  @Input() title2: string;
  @Input() showCloseButton = false;
  @Input() showInfoButton = false;
  @Input() showBackButton = false;
  @Input() infoTooltipText = "shared.learnMore";
  @Input() isInfoNavigation = true;
  @Output() closeButtonClick = new EventEmitter<void>();
  @Output() infoButtonClick = new EventEmitter<void>();
  @Output() infoButtonToggle = new EventEmitter<void>();
  @Output() backButtonClick = new EventEmitter<void>();

  onClose() {
    this.closeButtonClick.emit();
  }

  onInfo() {
    this.infoButtonClick.emit();
  }

  onInfoButtonToggle() {
    this.infoButtonToggle.emit();
  }

  onBack() {
    this.backButtonClick.emit();
  }
}
